import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { userService } from '../services/api';

const AddUser = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear messages when user starts typing
    setMessage(null);
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    setError(null);

    try {
      const response = await userService.create(formData);
      setMessage(response.message || `User "${formData.name}" created successfully!`);
      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
      });
    } catch (err) {
      console.error('Error creating user:', err);
      setError(err.response?.data?.error || 'Failed to create user. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-user-page">
      <div className="page-header">
        <Link to="/users" className="back-link">← Back to Users</Link>
        <h1>Add User</h1>
        <span className="subtitle">Create a new user — they can login via OTP at login.galigali.in</span>
      </div>

      <div className="form-container">
        <form onSubmit={handleSubmit} className="user-form">
          {message && (
            <div className="alert alert-success">
              ✅ {message} <Link to="/users" style={{ marginLeft: '0.5rem' }}>→ Go to Users</Link>
            </div>
          )}
          
          {error && (
            <div className="alert alert-error">
              ❌ {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="name">Full Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter full name"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email address"
              required
              disabled={loading}
            />
            <span className="form-hint">User will receive OTP login emails at this address</span>
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="+91 9876543210"
              disabled={loading}
            />
            <span className="form-hint">Include country code (e.g., +91 for India)</span>
          </div>

          <div className="form-actions">
            <button 
              type="submit" 
              className="btn btn-primary btn-lg"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="btn-spinner"></span>
                  Creating User...
                </>
              ) : (
                <>
                  👤 Create User
                </>
              )}
            </button>
            <Link to="/users" className="btn btn-secondary btn-lg">
              Cancel
            </Link>
          </div>
        </form>

        <div className="info-card">
          <h3>📝 What happens when you create a user?</h3>
          <ul>
            <li>User entry is created in the database</li>
            <li>User can login at <strong>login.galigali.in</strong> using their email</li>
            <li>An OTP (one-time password) is sent to their email for each login</li>
            <li>No passwords to manage — authentication is OTP-based</li>
            <li>You can assign tenant permissions after creating the user</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AddUser;
